import {
  getResponseByMode,
  showMessage,
  logMessage,
  debounce
} from './utils';
import {
  recaptchaSendHandler
} from './captcha';

export class Wholesalers {
  constructor() {
    this._form = document.querySelector('.wholesalers-request__form');
    if (this._form === null) {
      return;
    }
    this._wrapper = this._form.closest('.wholesalers-request__wrapper');
    this._submit = this._form.querySelector('button[type="submit"]');

    this._formSubmitHandler = this._formSubmitHandler.bind(this);
    this._load = debounce(this._load.bind(this));

    this._form.addEventListener('submit', this._formSubmitHandler);
  }

  _formSubmitHandler(evt) {
    evt.preventDefault();

    this._wrapper.classList.add('wholesalers-request__wrapper--loading');
    this._submit.disabled = true;

    const whenCaptchaReturnToken = recaptchaSendHandler(evt);
    const whenLoadData = this._load;

    whenCaptchaReturnToken
      .then(whenLoadData)
      .catch((error) => {
        console.warn(error);
        logMessage(error);
        showMessage(error.message);
      });

  }

  _load() {
    const mock = {
      url: 'mocks/wholesalers.json',
      options: {
        method: 'GET',
      }
    };

    const real = {
      url: this._form.action + '?ajax=1',
      options: {
        method: 'POST',
        body: new FormData(this._form)
      }
    };

    const {
      url,
      options
    } = getResponseByMode(mock, real);

    return fetch(url, options)
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error(`Неизвестный статус: ${response.status} ${response.statusText}`);
      })
      .then((data) => {
        if (data !== null) {
          throw new Error(data[0]);
        } else {
          this._wrapper.classList.add('wholesalers-request__wrapper--success');
        }
      })
      .catch((error) => {
        console.warn(error);
        logMessage(error);
        showMessage(error.message);
      })
      .finally(() => {
        this._wrapper.classList.remove('wholesalers-request__wrapper--loading');
        this._submit.disabled = false;
      });
  }
}
